module.exports = __webpack_public_path__ + "static/media/icon_no_landscape.96c25deb.png";